<section class="related-search" *ngIf="genereContent.length > 0">
  <div class="container">
    <div class="">
      <div class="section-head">
        <h2>{{ "SEARCH.EXPLORE_BY_GENERES" | translate }}</h2>
      </div>
    </div>
    <div class="row custome-set genere-row">
      <div
        *ngFor="let genere of genereContent"
        class="series-box genere-slider-box"
      >
        <!-- <a
          href="javascript:void(0)"
          class="btn btn-defult"
          routerLink="/genere-list/{{ genere.slug }}/movies"
        >
          {{ genere | languageTranslate }}
        </a> -->
        <div routerLink="/genere-list/{{ genere.slug }}/movies">
          <div class="ratio-slider ratio-16-9 genere-box">
            <img
              [src]="genere.image"
              [src-fallback]="appConstants.genreDefault"
            />
            <div class="h3-absolute">
              <div class="w-100">
                <h3 style="top: 0">{{ genere | languageTranslate }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
